module.exports = __webpack_public_path__ + "ci_vendor_sumo_logic.d98d0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/ci_vendor_sumo_logic.svg
// module id = ./src/_asset/sources/assets/images/@svg/ci_vendor_sumo_logic.svg
// module chunks = main